import './index.css';
import { useMemo } from 'react';
import { isDate, eachDayOfInterval, sub, add, startOfMonth, endOfMonth } from 'date-fns';
import { daysInWeek } from 'date-fns/constants';

const isDateType = (value) => {
    return isDate(value) || typeof value === 'number' || typeof value === 'string';
};
const getInfoByDateType = (holiday, shortWorkday) => {
    const text = holiday?.text || shortWorkday?.text || false;
    const header = holiday?.header || shortWorkday?.header || false;
    if (!text && !header) {
        return undefined;
    }
    return { text, header };
};
const flatten = (dates) => {
    return dates?.reduce((result, value) => {
        const interval = eachDayOfInterval(value.date).map((item) => ({
            date: item,
            ...(value.text ? { text: value.text, header: value.header } : {}),
        }));
        return isDateType(value.date) ? [...result, value] : [...result, ...interval];
    }, []);
};
/** Возвращает границы таблицы лет, в которой год displayDate находится посередине */
const makeYearsInterval = (displayDate) => {
    return {
        start: sub(displayDate, { years: 4 }),
        end: add(displayDate, { years: 7 }),
    };
};
const useDisplayDate = (displayDate, selectedDate) => {
    return useMemo(() => {
        if (displayDate) {
            return displayDate;
        }
        if (selectedDate) {
            return selectedDate;
        }
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }, [displayDate, selectedDate]);
};
const useDayPickerDates = (displayDate) => {
    return useMemo(() => {
        const startDateOfMonth = startOfMonth(displayDate);
        const endDateOfMonth = endOfMonth(displayDate);
        const paddingBefore = (daysInWeek + startDateOfMonth.getDay() - 1) % daysInWeek;
        const startDate = sub(startDateOfMonth, { days: paddingBefore });
        const paddingAfter = (daysInWeek - endDateOfMonth.getDay()) % daysInWeek;
        const endDate = add(endDateOfMonth, { days: paddingAfter });
        return eachDayOfInterval({ start: startDate, end: endDate });
    }, [displayDate]);
};

export { flatten, getInfoByDateType, isDateType, makeYearsInterval, useDayPickerDates, useDisplayDate };
//# sourceMappingURL=utils.js.map
